import { Poppins, Quicksand } from 'next/font/google'
import React, { Component } from 'react'
const quickSand = Quicksand({weight:"400",subsets:['latin']});
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "400", subsets: ['latin']});


export default class Relatedcourse extends Component {
  render() {
    const relatedcourse =[
      {
        id:1,
        path:`../${this.props.location}/${this.props.coupath}${this.props.url1}`,
        training:`${this.props.cou} ${this.props.location1}`,
      },
      {
        id:2,
        path:`../${this.props.location}/${this.props.coupath1}${this.props.url1}`,
        training:`${this.props.cou1} ${this.props.location1}`,
      },
      {
        id:3,
        path:`../${this.props.location}/${this.props.coupath2}${this.props.url1}`,
        training:`${this.props.cou2} ${this.props.location1}`,
      },
      {
        id:4,
        path:`../${this.props.location}/${this.props.coupath3}${this.props.url1}`,
        training:`${this.props.cou3} ${this.props.location1}`,
      },
      {
        id:5,
        path:`../${this.props.location}/${this.props.coupath4}${this.props.url1}`,
        training:`${this.props.cou4} ${this.props.location1}`,
      },{
        id:6,
        path:`../${this.props.location}/${this.props.coupath5}${this.props.url1}`,
        training:`${this.props.cou5} ${this.props.location1}`,
      },
      {
        id:7,
        path:`../${this.props.location}/${this.props.coupath6}${this.props.url1}`,
        training:`${this.props.cou6} ${this.props.location1}`,
      },
      {
        id:8,
        path:`../${this.props.location}/${this.props.coupath7}${this.props.url1}`,
        training:`${this.props.cou7} ${this.props.location1}`,
      },
      {
        id:9,
        path:`../${this.props.location}/${this.props.coupath8}${this.props.url1}`,
        training:`${this.props.cou8} ${this.props.location1}`,
      },
      {
        id:10,
        path:`../${this.props.location}/${this.props.coupath9}${this.props.url1}`,
        training:`${this.props.cou9} ${this.props.location1}`,
      },
    ]
    return (
      <>
        <section className='related-bg pdtb50 mpdtb30'>
          <div className='container df fjc '>
            <div className='con-1100 tac'>
            <h3 className={`tac fs-32 mfs-24 ylw-clr mpdb10 ${extraPopins.className}`}>Related {this.props.location1}</h3>
            <div className='df fw pdt20 mpdt0 fjc'>
            {relatedcourse.map((relatedcourse) => {
              return (
                <div key={relatedcourse.id}>
                <a href={relatedcourse.path}>
 
                    <div >
                      <div className='box'>
                        <h4 className={`df pd5 fs-16 mfs-12 ${quickSand.className}`}>{relatedcourse.training}</h4>

                    </div>
                  </div>
                </a>
                </div>
              )
            })}
            </div>
          </div>
          </div>
          <style jsx>
            {`
             .box{
              border-right:1px solid #000;
             }
             .related-bg{
         background-color:#FEECCD;
         height: 160px;
             }
             .con-1100{
                max-width: 1100px;
                width: 100%;
                margin: 0 auto;
                flex: 1 100px;
             }
             @media only screen and (max-width: 1023px){
                .related-bg{
                    background-color:#FEECCD;
                    height: 100%;
                    
                        }
                        .box{
                          border:1px solid #000;
                          margin-top:10px;
                          min-width:280px;
                          max-width:320px;
                         }
             }
            `}
          </style>
        </section>
      </>
    )
  }
}  
